import moment from 'moment';

/**
 * Formats a duration as its non-zero units, largest first (e.g. `1 h 1 min 1 sec`).
 * Returns `undefined` for a zero duration. Co-agent charts label seconds as `s`,
 * so the seconds suffix is configurable.
 */
export const formatDuration = (
  period = 0,
  unit: moment.unitOfTime.DurationConstructor = 'seconds',
  secondsSuffix = ' sec',
): string | undefined => {
  const parts = [];
  const duration = moment.duration(period, unit);

  if (!duration || duration.toISOString() === 'P0D') return;

  if (duration.years() >= 1) {
    parts.push(`${Math.floor(duration.years())} y`);
  }

  if (duration.months() >= 1) {
    parts.push(`${Math.floor(duration.months())} m`);
  }

  if (duration.days() >= 1) {
    parts.push(`${Math.floor(duration.days())} d`);
  }

  if (duration.hours() >= 1) {
    parts.push(`${Math.floor(duration.hours())} h`);
  }

  if (duration.minutes() >= 1) {
    parts.push(`${Math.floor(duration.minutes())} min`);
  }

  if (duration.seconds() >= 1) {
    parts.push(`${Math.floor(duration.seconds())}${secondsSuffix}`);
  }

  return parts.join(' ');
};
